import {ProductStockBadge} from "./stock_badge.js";
import {AddToOrderListBtn} from "./add_to_orderlist_btn.js";
import {AddToShoppingCartBtn} from "./add_to_shopping_cart_btn.js";
import {PriceElements} from "./price_elements.js";
import {OrderedBeforeBadge} from "./ordered_before_badge.js";
import {ArticleNumberBadge} from "./article_number_badge.js";
import {ActionProductRibbon} from "./action_product_ribbon.js";
import {ProductImage} from "./product_image.js";
import {quickAddCounterHtml, quickAddStep} from "../../helpers/shopping_cart/quick_add.js";

export class ProductTableRow {
    constructor(product, showNetPrices = false) {

        this.product = product;
        this.showNetPrices = showNetPrices;
        this.isSignedIn = $('body').attr('data-is-signed-in') === '1';
    }

    render() {

        // match_explanation is only ever present when the server has already
        // verified admin permission + investigation mode (see
        // ProductsSearchHelperComponent::_applyMatchExplanationsToResults()) -
        // its mere presence here is the gate, no separate client-side
        // permission check needed.
        const explanations = Array.isArray(this.product.match_explanation) ? this.product.match_explanation : [];
        const investigationHtml = explanations.length > 0
            ? `<button type="button" class="btn btn-outline-secondary btn-sm py-0 px-1 mt-1" data-bs-toggle="collapse" data-bs-target="#investigation-` + this.product.id + `" onclick="event.stopPropagation()">
                    <i class="ai-search fs-sm"></i> Waarom dit resultaat?
                </button>
                <div class="collapse" id="investigation-` + this.product.id + `">
                    <ul class="list-unstyled fs-xs text-muted mb-0 mt-1 text-start">
                        ` + explanations.map(e => `<li>&quot;` + e.term + `&quot; - ` + e.label + (e.value ? ': ' + e.value : '') + `</li>`).join('') + `
                    </ul>
                </div>`
            : '';

        return `<tr class="product-search-result-item-row" data-product-id="` + this.product.id + `">
                    ` + new ProductImage(this.product).render() + `
                    <td class="align-middle" onclick="document.location = '/product/` + this.product.id + `'">
                        <div class="d-flex align-items-center">
                            ` + new ArticleNumberBadge(this.product, false).render() + `
                        </div>
                    </td>
                    <td class="align-middle product-link" data-product-id="` + this.product.id + `" onclick="document.location = '/product/` + this.product.id + `'"><h3 class="h6 m-0" style="color: var(--ar-heading-link-color) !important;">` + this.product.description + `</h3>` + investigationHtml + `</td>
                    <td class="align-middle product-link" data-product-id="` + this.product.id + `" onclick="document.location = '/product/` + this.product.id + `'"><div class="d-flex flex-column justify-content-center align-items-center product-price-elements">` + new PriceElements(this.product, this.showNetPrices).render() + `</div></td>
                    <td class="align-middle position-relative">
                        <div class="d-flex flex-row gap-2 justify-content-end align-items-center quick-add-host">
                            ` + new OrderedBeforeBadge(this.product, false).render() + `
                            ` + new ProductStockBadge(this.product, false).render() + `
                            ` + new AddToOrderListBtn(this.product, false).render() + `
                            ` + (this.isSignedIn ? quickAddCounterHtml(quickAddStep(this.product), 'quick-add-inline bg-gray rounded-pill d-none d-md-inline-flex') : '') + `
                            ` + new AddToShoppingCartBtn(this.product, false).render() + `
                        </div>
                        ` + new ActionProductRibbon(this.product, false).render() + `
                    </td>
                </tr>`;
    }
}
